<template>
  <div class="modal" @click="$emit('close')">
    <div class="modal__body" @click.stop>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalTemplate",
};
</script>

<style scoped lang="scss">
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);

  &__body {
    background: white;
    width: 90%;
    max-width: 400px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    border-radius: 10px;
  }
}
</style>
